import React from 'react';
import styled from 'styled-components';

import WalletHeader from '#/components/wallet/dashboard/header/WalletHeader';
import useRedirectNonMobile from '#/hooks/useRedirectNonMobile';

import RewardsMenuSection from './RewardsMenuSection';

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export default function RewardsMenuPageMobile() {
  useRedirectNonMobile('/');
  return (
    <Wrap>
      <WalletHeader title="Rewards" noBack showBalanceActions />
      <RewardsMenuSection />
    </Wrap>
  );
}
